import { Player } from "@lottiefiles/react-lottie-player"
import { GlobalStateContext } from "GlobalState"
import utils from "modules/utils"
import { useContext } from "react"
import CTABtn from "./CTABtn"
import { Column } from "./Layout"
import css from "./MainFTUE.module.scss"

export default function MainFTUE() {
    const { setMainFTUECompleted } = useContext(GlobalStateContext)

    function closeFTUE() {
        setMainFTUECompleted(true)
    }

    return (
        <Column align="lsb" className={css.mainFTUE} padding="4rem 2rem 2rem" gap={20}>
            <img src="/img/ftue_title.svg" width={204} height={184} alt="" />

            <div style={{ flex: 1, position: 'relative' }}>
                <Player
                    autoplay
                    loop
                    src={utils.fetchLottie("/lottie/main_ftue.json")}
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 480,
                        height: 386,
                    }}
                />
            </div>

            <CTABtn
                onClick={closeFTUE}
                iconRight={'arrow-right'}
                iconSize={22}
                type="large"
            >
                Start Playing Now
            </CTABtn>
        </Column >
    )
}
